export class LoginModel {
    // tslint:disable-next-line:variable-name
    email: string;
    password: string;
  
    constructor() {
      this.email = '';
      this.password = '';
    }
}